module.exports = __webpack_public_path__ + "img/digitalis_farm_adatbazis_pop_up.3648457f.png";